import { GoLink, Section, ringedBand } from "@/features/portal/components/portal-ui";
import { StoreButtons } from "@/features/portal/components/store-buttons";
import { cn } from "@/lib/utils";
import { m } from "@/paraglide/messages.js";

/** Where a page of the tour ends: get the app, or find somebody to train with first. */
export const ClosingBand = () => (
  <Section>
    <div className={cn(ringedBand, "px-6 py-14 text-center md:py-20")}>
      <h2 className="mx-auto max-w-[20ch] text-[clamp(1.9rem,4vw,3.25rem)] leading-[1.02] font-medium tracking-[-0.045em] text-balance">
        {m.portal_features_closing_title()}
      </h2>
      <p className="mx-auto mt-5 max-w-[46ch] text-[17px] leading-relaxed text-primary-foreground/75">{m.portal_features_closing_body()}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <GoLink to="/coaches">
          {m.portal_features_closing_cta()}
        </GoLink>
        <StoreButtons tone="ink" />
      </div>
    </div>
  </Section>
);
